interface ThirdPartyAuthTokenParameters {
    aud: string;
    azp: string;
    emails: string[];
    exp: number;
    family_name: string;
    given_name: string;
    iat: number;
    idp: string;
    iss: string;
    name: string;
    nbf: number;
    oid: string;
    scp: string;
    sub: string;
    tfp: string;
    ver: string;
}

export default class ThirdPartyAuthToken {
    public aud: string;
    public azp: string;
    public emails: string[];
    public exp: number;
    public family_name: string;
    public given_name: string;
    public iat: number;
    public idp: string;
    public iss: string;
    public name: string;
    public nbf: number;
    public oid: string;
    public scp: string;
    public sub: string;
    public tfp: string;
    public ver: string;


    public constructor(params: ThirdPartyAuthTokenParameters) {
        this.aud = params.aud;
        this.azp = params.azp;
        this.emails = params.emails;
        this.exp = params.exp;
        this.family_name = params.family_name;
        this.given_name = params.given_name;
        this.iat = params.iat;
        this.idp = params.idp;
        this.iss = params.iss;
        this.name = params.name;
        this.nbf = params.nbf;
        this.oid = params.oid;
        this.scp = params.scp;
        this.sub = params.sub;
        this.tfp = params.tfp;
        this.ver = params.ver;
    }
}